import React from 'react';
import FooterPresenter from './FooterPresenter';

const FooterContainer: React.FC = () => {
  return <FooterPresenter />;
};

export default FooterContainer;
